export enum NoticePeriodUnit {
	WEEK = 'week',
	MONTH = 'month'
}

export interface INoticePeriod {
	min: number;
	max: number;
	unit: NoticePeriodUnit;
}
